// competition-schedule.js — Tab 1: Schedule management + recap import.
// Extracted verbatim from competition.js (F.4.1).
// Exports renderScheduleTab(schedule, clients) and initScheduleHandlers().

import { apiFetch, formatDate } from './utils.js';

export async function renderScheduleTab(schedule, clients) {
  const upcoming = schedule.filter(e => new Date(e.event_date) >= new Date());
  const past     = schedule.filter(e => new Date(e.event_date) <  new Date());

  return `
    <div class="competition-header">
      <h2>Competition Schedule</h2>
      <div class="competition-controls">
        <select id="filter-comp-client" onchange="window.filterCompSchedule()" class="filter-select">
          <option value="">All Clients</option>
          ${clients.map(c => `<option value="${c.id}">${c.org_name} (${c.director_name || '—'})</option>`).join('')}
        </select>
        <button class="btn-add-event" onclick="window.openAddEventModal()">+ Add Event</button>
        <button class="btn-import-recap" onclick="window.openStandaloneRecapImport()">Import Recap</button>
        <button class="btn-run-scrape" onclick="window.runManualScrape()">Run Scrape</button>
      </div>
    </div>

    <div class="schedule-section">
      <div class="section-label">Upcoming Events</div>
      ${renderScheduleTable(upcoming, false)}
    </div>

    ${past.length > 0 ? `
      <div class="schedule-section past-section">
        <div class="section-label">Past Events</div>
        ${renderScheduleTable(past, true)}
      </div>
    ` : ''}

    <div class="results-section">
      <div class="section-label">Results</div>
      <div id="results-list">
        <div class="empty-state">Click an event row to view results</div>
      </div>
    </div>

    <div class="competition-footer">
      <button class="btn-monday-email" onclick="window.openMondayEmailComposer()">
        Compose Monday Director Email →
      </button>
    </div>

    ${renderAddEventModal(clients)}
    ${renderStandaloneImportModal()}
  `;
}

function renderScheduleTable(events, isPast) {
  if (!events || events.length === 0) {
    return `<div class="empty-state">${isPast ? 'No past events.' : 'No upcoming events. Add events from director schedules.'}</div>`;
  }
  return `
    <table class="schedule-table">
      <thead>
        <tr>
          <th>Date</th><th>Event</th><th>Venue</th><th>Circuit</th><th>Division</th><th>Client</th><th>Results</th><th></th>
        </tr>
      </thead>
      <tbody>
        ${events.map(event => `
          <tr class="schedule-row ${event.scrape_successful ? 'has-results' : ''}"
              onclick="window.loadEventResults(${event.id})">
            <td class="event-date">${formatDate(event.event_date)}</td>
            <td class="event-name">${event.event_name}</td>
            <td class="event-venue">${[event.venue_city, event.venue_state].filter(Boolean).join(', ') || '—'}</td>
            <td class="event-circuit">${event.circuit || '—'}</td>
            <td class="event-division">${event.division || '—'}</td>
            <td class="event-client">${event.client_name || '—'}</td>
            <td class="event-status">
              ${event.scrape_successful
                ? '<span class="status-dot green" title="Results available"></span>'
                : event.scrape_attempted_at
                  ? '<span class="status-dot amber" title="Scrape attempted, no results"></span>'
                  : '<span class="status-dot gray" title="Not scraped yet"></span>'}
            </td>
            <td class="event-delete" onclick="event.stopPropagation()">
              <button class="btn-delete-event" onclick="window.deleteCompEvent(${event.id})" title="Delete event">×</button>
            </td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
}

function renderAddEventModal(clients) {
  return `
    <div id="add-event-modal" class="modal-overlay hidden">
      <div class="modal-dialog">
        <div class="modal-header">
          <span>Add Competition Event</span>
          <button class="modal-close-btn" onclick="document.getElementById('add-event-modal').classList.add('hidden')">×</button>
        </div>
        <div class="modal-body">
          <div class="form-field">
            <label>Client</label>
            <select id="ae-client" class="form-input">
              <option value="">— select —</option>
              ${clients.map(c => `<option value="${c.id}">${c.org_name} (${c.director_name || '—'})</option>`).join('')}
            </select>
          </div>
          <div class="form-field">
            <label>Event Name</label>
            <input type="text" id="ae-name" class="form-input" placeholder="e.g. SEMBA Championship">
          </div>
          <div class="form-field">
            <label>Date</label>
            <input type="date" id="ae-date" class="form-input">
          </div>
          <div class="form-row">
            <div class="form-field">
              <label>City</label>
              <input type="text" id="ae-city" class="form-input">
            </div>
            <div class="form-field">
              <label>State</label>
              <input type="text" id="ae-state" class="form-input" maxlength="2" style="width:60px">
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label>Circuit</label>
              <input type="text" id="ae-circuit" class="form-input" placeholder="BOA, WGI, SEMBA…">
            </div>
            <div class="form-field">
              <label>Division</label>
              <input type="text" id="ae-division" class="form-input" placeholder="5A, Open…">
            </div>
          </div>
          <div class="form-field">
            <label>Results URL (optional)</label>
            <input type="url" id="ae-url" class="form-input" placeholder="Direct URL to results page">
          </div>
        </div>
        <div class="modal-footer">
          <button onclick="window.saveNewEvent()" class="btn-primary">Add Event</button>
        </div>
      </div>
    </div>
  `;
}

function renderStandaloneImportModal() {
  return `
    <div id="standalone-recap-modal" class="modal-overlay hidden">
      <div class="modal-dialog" style="max-width:680px;max-height:90vh;display:flex;flex-direction:column">
        <div class="modal-header" style="flex-shrink:0">
          <span>Import Recap Scoresheet</span>
          <button class="modal-close-btn" onclick="document.getElementById('standalone-recap-modal').classList.add('hidden');window.resetStandaloneImport()">×</button>
        </div>
        <div class="modal-body" id="standalone-import-body" style="overflow-y:auto;flex:1;min-height:0">

          <!-- Step 1: Upload (single or batch) -->
          <div id="standalone-step-upload">
            <p style="margin-bottom:1rem;color:var(--text-muted);font-size:.875rem">
              Upload one scoresheet or select multiple files (up to 8) for batch import. No client required.
            </p>
            <div class="form-field">
              <label>Scoresheet</label>
              <input type="file" id="standalone-file-input" accept=".jpg,.jpeg,.png,.pdf" multiple
                onchange="window._onBatchFileChange(this)" style="font-size:.85rem">
              <div id="standalone-file-warning" style="margin-top:.3rem;font-size:.8rem"></div>
            </div>
            <div id="standalone-extract-status" style="margin-top:.5rem;color:var(--text-muted);font-size:.85rem"></div>
            <div class="modal-footer" style="margin-top:1rem">
              <button onclick="window.runStandaloneExtract()" class="btn-primary" id="standalone-extract-btn">Extract →</button>
            </div>
          </div>

          <!-- Step 2a: Single-file review -->
          <div id="standalone-step-review" style="display:none">
            <div id="standalone-review-content"></div>
            <div id="standalone-format-warning" style="display:none;margin-top:.75rem;padding:.75rem;background:rgba(255,200,0,.1);border:1px solid rgba(255,200,0,.3);border-radius:6px;font-size:.8rem;color:#e5c900"></div>
            <div class="modal-footer" style="position:sticky;bottom:0;gap:.5rem;display:flex;background:#1b2535;padding:.75rem 0 .25rem;margin-top:.75rem">
              <button onclick="window.resetStandaloneImport()" class="btn-secondary">← Back</button>
              <button onclick="window.confirmStandaloneImport()" class="btn-primary" id="standalone-confirm-btn">Confirm Import</button>
            </div>
          </div>

          <!-- Step 2b: Batch extraction progress -->
          <div id="standalone-step-batch-progress" style="display:none">
            <div id="batch-progress-header" style="font-size:.85rem;margin-bottom:.75rem;color:var(--text-muted)">Preparing…</div>
            <div id="batch-progress-list" style="font-size:.82rem"></div>
          </div>

          <!-- Step 2c: Batch review -->
          <div id="standalone-step-batch-review" style="display:none">
            <div id="standalone-batch-review-content"></div>
            <div class="modal-footer" style="position:sticky;bottom:0;gap:.5rem;display:flex;background:#1b2535;padding:.75rem 0 .25rem;margin-top:.75rem">
              <button onclick="window.resetStandaloneImport()" class="btn-secondary">← Back</button>
              <button onclick="window.confirmBatchImport()" class="btn-primary" id="batch-confirm-btn">Import All</button>
            </div>
          </div>

        </div>
      </div>
    </div>`;
}

// ── Window handlers ──────────────────────────────────────────────────────────

export function initScheduleHandlers() {
  let _saExtracted = null;
  let _saDetection = null;
  let _batchResults = [];   // [{file, extracted, detection, error}]

  const BATCH_MAX  = 8;
  const BATCH_WARN = 6;

  const ALL_STEPS = ['standalone-step-upload','standalone-step-review',
                     'standalone-step-batch-progress','standalone-step-batch-review'];

  function showStep(id) {
    ALL_STEPS.forEach(s => {
      const el = document.getElementById(s);
      if (el) el.style.display = s === id ? '' : 'none';
    });
  }

  window.loadEventResults = async function(scheduleId) {
    const el = document.getElementById('results-list');
    if (!el) return;
    el.innerHTML = '<div class="loading-state">Loading results…</div>';
    try {
      const results = await apiFetch(`/api/competition/results/by-schedule/${scheduleId}`).catch(() => []);
      const list = Array.isArray(results) ? results : [];
      if (!list.length) { el.innerHTML = '<div class="empty-state">No results yet for this event</div>'; return; }
      el.innerHTML = list.map(r => {
        let awards = [];
        try { awards = Array.isArray(r.caption_awards) ? r.caption_awards : JSON.parse(r.caption_awards || '[]'); } catch {}
        let captions = {};
        try { captions = typeof r.caption_scores === 'object' ? r.caption_scores : JSON.parse(r.caption_scores || '{}'); } catch {}
        return `
          <div class="result-card">
            <div class="result-header">
              <span class="result-type">${r.result_type}</span>
              ${r.placement ? `<span class="result-placement">${ordinal(r.placement)} place</span>` : ''}
              ${r.total_score ? `<span class="result-score">${r.total_score}</span>` : ''}
            </div>
            ${awards.length > 0 ? `<div class="result-awards">${awards.map(a => `<span class="award-badge">${a}</span>`).join('')}</div>` : ''}
            ${Object.keys(captions).length > 0 ? `
              <div class="result-captions">
                ${Object.entries(captions).map(([k, v]) =>
                  `<span class="caption-score"><span class="caption-name">${k}</span> ${v}</span>`
                ).join('')}
              </div>` : ''}
          </div>`;
      }).join('');
    } catch {
      el.innerHTML = '<div class="error-state">Failed to load results</div>';
    }
  };

  window.filterCompSchedule = function() {
    window.renderCompetitionView();
  };

  window.runManualScrape = async function() {
    const btn = document.querySelector('.btn-run-scrape');
    if (btn) { btn.textContent = 'Running…'; btn.disabled = true; }
    try {
      const result = await apiFetch('/api/competition/run-scrape', { method: 'POST' });
      alert(`Scrape complete: ${result.successful || 0}/${result.events_checked || 0} events found results`);
      window.renderCompetitionView();
    } catch (err) {
      alert('Scrape failed: ' + err.message);
    } finally {
      if (btn) { btn.textContent = 'Run Scrape'; btn.disabled = false; }
    }
  };

  window.openAddEventModal = function() {
    document.getElementById('add-event-modal')?.classList.remove('hidden');
  };

  window.saveNewEvent = async function() {
    const data = {
      client_id:   document.getElementById('ae-client')?.value,
      event_name:  document.getElementById('ae-name')?.value,
      event_date:  document.getElementById('ae-date')?.value,
      venue_city:  document.getElementById('ae-city')?.value,
      venue_state: document.getElementById('ae-state')?.value,
      circuit:     document.getElementById('ae-circuit')?.value,
      division:    document.getElementById('ae-division')?.value,
      event_url:   document.getElementById('ae-url')?.value,
    };
    if (!data.client_id || !data.event_name || !data.event_date) {
      alert('Client, event name, and date are required'); return;
    }
    try {
      await apiFetch('/api/competition/schedule', { method: 'POST', body: JSON.stringify(data) });
      document.getElementById('add-event-modal')?.classList.add('hidden');
      window.renderCompetitionView();
    } catch (err) {
      alert('Failed to add event: ' + err.message);
    }
  };

  window.deleteCompEvent = async function(id) {
    if (!confirm('Delete this event and all associated results?')) return;
    try {
      await apiFetch(`/api/competition/schedule/${id}`, { method: 'DELETE' });
      window.renderCompetitionView();
    } catch (err) {
      alert('Failed to delete event: ' + err.message);
    }
  };

  window.openMondayEmailComposer = function() {
    const btn = document.querySelector('[data-view="inbox"]');
    if (btn) btn.click();
    else if (window.renderEmailView) window.renderEmailView();
  };

  // ── Import modal handlers ──────────────────────────────────────────────────

  window.openStandaloneRecapImport = function() {
    window.resetStandaloneImport();
    document.getElementById('standalone-recap-modal')?.classList.remove('hidden');
  };

  window.resetStandaloneImport = function() {
    _saExtracted = null;
    _saDetection = null;
    _batchResults = [];
    showStep('standalone-step-upload');
    const st = document.getElementById('standalone-extract-status');
    if (st) st.textContent = '';
    const fi = document.getElementById('standalone-file-input');
    if (fi) fi.value = '';
    const fw = document.getElementById('standalone-file-warning');
    if (fw) fw.textContent = '';
  };

  window._onBatchFileChange = function(input) {
    const n = input.files.length;
    const warn = document.getElementById('standalone-file-warning');
    if (!warn) return;
    if (n > BATCH_MAX) {
      warn.style.color = '#e05252';
      warn.textContent = `${n} files selected — maximum is ${BATCH_MAX}. Please deselect some.`;
    } else if (n >= BATCH_WARN) {
      warn.style.color = '#e5c900';
      warn.textContent = `${n} files selected — extraction will take ~${n * 12}–${n * 15}s.`;
    } else if (n > 1) {
      warn.style.color = 'var(--text-muted)';
      warn.textContent = `${n} files selected — batch mode.`;
    } else {
      warn.textContent = '';
    }
  };

  window.runStandaloneExtract = async function() {
    const fileInput = document.getElementById('standalone-file-input');
    if (!fileInput?.files?.length) { alert('Please select a scoresheet file'); return; }

    const files = Array.from(fileInput.files);
    if (files.length > BATCH_MAX) {
      alert(`Maximum ${BATCH_MAX} files per batch. Please select fewer files.`);
      return;
    }

    if (files.length === 1) {
      await runSingleExtract(files[0]);
    } else {
      await runBatchExtract(files);
    }
  };

  // ── Single-file extraction (unchanged logic) ───────────────────────────────

  async function runSingleExtract(file) {
    const statusEl = document.getElementById('standalone-extract-status');
    const btn      = document.getElementById('standalone-extract-btn');
    if (statusEl) statusEl.textContent = 'Extracting with Claude… this takes ~10s';
    if (btn) btn.disabled = true;
    try {
      const fd = new FormData();
      fd.append('image', file);
      const resp = await fetch('/api/competition/import/extract', { method: 'POST', body: fd });
      const data = await resp.json();
      if (data.error) throw new Error(data.error);
      _saExtracted = data;

      const circuit = data.competition?.circuit_guess;
      const season  = data.competition?.event_date ? parseInt(data.competition.event_date.slice(0, 4)) : null;
      if (circuit && season && Array.isArray(data.raw_captions)) {
        try {
          _saDetection = await apiFetch('/api/competition/detect-format', {
            method: 'POST',
            body: JSON.stringify({ circuit, season, raw_captions: data.raw_captions })
          });
        } catch { _saDetection = null; }
      }

      showStep('standalone-step-review');
      document.getElementById('standalone-review-content').innerHTML = renderStandaloneReview(_saExtracted, _saDetection);

      const warnEl = document.getElementById('standalone-format-warning');
      if (_saDetection && _saDetection.match !== 'exact') {
        const unmatched = (_saDetection.unmatched || []).map(u => u.raw_name).join(', ');
        warnEl.style.display = '';
        warnEl.textContent = _saDetection.match === 'partial'
          ? `Format partially matched (${_saDetection.format_name}). Unmatched: ${unmatched}`
          : `Format not matched for circuit "${circuit}". Importing without normalization.`;
      } else if (warnEl) { warnEl.style.display = 'none'; }
    } catch (err) {
      if (statusEl) statusEl.textContent = 'Extraction failed: ' + err.message;
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  // ── Batch extraction ───────────────────────────────────────────────────────

  async function runBatchExtract(files) {
    _batchResults = files.map(f => ({ file: f, extracted: null, detection: null, error: null }));

    showStep('standalone-step-batch-progress');

    const listEl = document.getElementById('batch-progress-list');
    if (listEl) {
      listEl.innerHTML = files.map((f, i) =>
        `<div id="batch-prog-row-${i}" style="display:flex;align-items:center;gap:.6rem;padding:.3rem 0;border-bottom:1px solid rgba(255,255,255,.05)">
          <span id="batch-prog-icon-${i}" style="width:16px;text-align:center;color:var(--text-muted)">·</span>
          <span style="font-size:.82rem;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${f.name}</span>
          <span id="batch-prog-status-${i}" style="font-size:.78rem;color:var(--text-muted)">queued</span>
        </div>`
      ).join('');
    }

    for (let i = 0; i < files.length; i++) {
      const headerEl = document.getElementById('batch-progress-header');
      if (headerEl) headerEl.textContent = `Extracting ${i + 1} of ${files.length}…`;

      const icon   = document.getElementById(`batch-prog-icon-${i}`);
      const status = document.getElementById(`batch-prog-status-${i}`);
      if (icon)   { icon.textContent = '⟳'; icon.style.color = '#e5c900'; }
      if (status) { status.textContent = 'extracting…'; status.style.color = '#e5c900'; }

      try {
        const fd = new FormData();
        fd.append('image', files[i]);
        const resp = await fetch('/api/competition/import/extract', { method: 'POST', body: fd });
        const data = await resp.json();
        if (data.error) throw new Error(data.error);
        _batchResults[i].extracted = data;

        const circuit = data.competition?.circuit_guess;
        const season  = data.competition?.event_date ? parseInt(data.competition.event_date.slice(0, 4)) : null;
        if (circuit && season && Array.isArray(data.raw_captions)) {
          try {
            _batchResults[i].detection = await apiFetch('/api/competition/detect-format', {
              method: 'POST',
              body: JSON.stringify({ circuit, season, raw_captions: data.raw_captions })
            });
          } catch { _batchResults[i].detection = null; }
        }

        if (icon)   { icon.textContent = '✓'; icon.style.color = '#4caf50'; }
        if (status) { status.textContent = `${data.entries?.length || 0} bands`; status.style.color = '#4caf50'; }
      } catch (err) {
        _batchResults[i].error = err.message;
        if (icon)   { icon.textContent = '✗'; icon.style.color = '#e05252'; }
        if (status) { status.textContent = err.message; status.style.color = '#e05252'; }
      }
    }

    const successCount = _batchResults.filter(r => r.extracted && !r.error).length;
    const headerEl = document.getElementById('batch-progress-header');
    if (headerEl) headerEl.textContent = `Done — ${successCount} of ${files.length} extracted successfully.`;

    showStep('standalone-step-batch-review');
    const reviewEl = document.getElementById('standalone-batch-review-content');
    if (reviewEl) reviewEl.innerHTML = renderBatchReview(_batchResults);

    const confirmBtn = document.getElementById('batch-confirm-btn');
    if (confirmBtn) confirmBtn.textContent = `Import All (${successCount})`;
  }

  // ── Single-file confirm ────────────────────────────────────────────────────

  window.confirmStandaloneImport = async function() {
    if (!_saExtracted) return;
    const btn = document.getElementById('standalone-confirm-btn');
    if (btn) btn.disabled = true;
    const data = _saExtracted;
    const comp = data.competition || {};

    const compName  = document.getElementById('sa-comp-name')?.value?.trim() || comp.name || 'Unknown Competition';
    const compDate  = document.getElementById('sa-comp-date')?.value?.trim() || comp.event_date || '';
    const circuit   = document.getElementById('sa-comp-circuit')?.value || comp.circuit_guess || '';
    const compRound = document.getElementById('sa-comp-round')?.value || comp.round || 'regular';
    const season    = compDate ? parseInt(compDate.slice(0, 4)) : null;

    if (!compDate) {
      alert('Event date is required — please enter it above');
      if (btn) btn.disabled = false;
      return;
    }
    if (!circuit) {
      alert('Circuit is required — please select one above');
      if (btn) btn.disabled = false;
      return;
    }

    const matchByRaw = {};
    for (const m of (_saDetection?.matched || [])) matchByRaw[m.raw_name] = m;

    const allEntriesWithClass = (data.entries || []).map((e, i) => {
      const classInput   = document.getElementById(`sa-band-class-${i}`)?.value?.trim();
      const placementRaw = document.getElementById(`sa-band-placement-${i}`)?.value?.trim();
      return {
        ...e,
        classification: classInput || e.classification || null,
        placement: placementRaw ? parseInt(placementRaw, 10) : e.placement,
      };
    });

    if (allEntriesWithClass.length === 0) {
      alert('No bands selected — check at least one classification group');
      if (btn) btn.disabled = false;
      return;
    }

    const payload = {
      format_id: _saDetection?.format_id || null,
      competition: {
        name: compName, event_date: compDate,
        host_school: comp.host || null, circuit, season,
        round: compRound, classification: comp.classification || null
      },
      entries: allEntriesWithClass.map(e => ({
        band_name: e.band_name, placement: e.placement,
        classification: e.classification || null,
        class_size: e.class_size || null,
        total_score: e.total_score, subtotal: e.subtotal, penalty: e.penalty,
        caption_scores: (e.caption_scores || []).flatMap(cs => {
          const def  = matchByRaw[cs.raw_name];
          const base = { caption_def_id: def?.caption_def_id || null, caption_raw_name: cs.raw_name, judge_name: cs.judge_name, panel_id: cs.panel_id };
          const result = [];
          if (cs.sub_score_1   != null) result.push({ ...base, sub_score_1:   cs.sub_score_1   });
          if (cs.sub_score_2   != null) result.push({ ...base, sub_score_2:   cs.sub_score_2   });
          if (cs.caption_total != null) result.push({ ...base, caption_total: cs.caption_total });
          return result;
        })
      }))
    };

    try {
      const result = await apiFetch('/api/competition/import/confirm', { method: 'POST', body: JSON.stringify(payload) });
      document.getElementById('standalone-recap-modal')?.classList.add('hidden');
      window.resetStandaloneImport();
      alert(`Imported: ${result.inserted_entries} band${result.inserted_entries !== 1 ? 's' : ''} for "${result.competition?.name || 'competition'}"`);
      await window.renderCompetitionView();
    } catch (err) {
      alert('Import failed: ' + err.message);
      if (btn) btn.disabled = false;
    }
  };

  // ── Batch confirm ──────────────────────────────────────────────────────────

  window.confirmBatchImport = async function() {
    const btn = document.getElementById('batch-confirm-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Importing…'; }

    let imported = 0;
    let failed   = 0;

    for (let i = 0; i < _batchResults.length; i++) {
      const r = _batchResults[i];
      if (!r.extracted) continue;

      const statusEl = document.getElementById(`batch-review-status-${i}`);
      if (statusEl) { statusEl.textContent = 'importing…'; statusEl.style.color = '#e5c900'; }

      try {
        const payload = buildBatchPayload(i, r);
        const result  = await apiFetch('/api/competition/import/confirm', { method: 'POST', body: JSON.stringify(payload) });
        imported++;
        if (statusEl) { statusEl.textContent = `✓ ${result.inserted_entries} band${result.inserted_entries !== 1 ? 's' : ''} imported`; statusEl.style.color = '#4caf50'; }
      } catch (err) {
        failed++;
        if (statusEl) { statusEl.textContent = `✗ ${err.message}`; statusEl.style.color = '#e05252'; }
      }
    }

    document.getElementById('standalone-recap-modal')?.classList.add('hidden');
    window.resetStandaloneImport();
    const msg = `Imported ${imported} competition${imported !== 1 ? 's' : ''}${failed ? `, ${failed} failed` : ''}.`;
    alert(msg);
    await window.renderCompetitionView();
  };

  function buildBatchPayload(i, r) {
    const data = r.extracted;
    const comp = data.competition || {};
    const detection = r.detection;

    const compName  = document.getElementById(`sa-batch-name-${i}`)?.value?.trim()    || comp.name         || 'Unknown Competition';
    const compDate  = document.getElementById(`sa-batch-date-${i}`)?.value?.trim()    || comp.event_date   || '';
    const circuit   = document.getElementById(`sa-batch-circuit-${i}`)?.value         || comp.circuit_guess || '';
    const compRound = document.getElementById(`sa-batch-round-${i}`)?.value           || comp.round        || 'regular';
    const season    = compDate ? parseInt(compDate.slice(0, 4)) : null;

    const matchByRaw = {};
    for (const m of (detection?.matched || [])) matchByRaw[m.raw_name] = m;

    const entries = (data.entries || []).map((e, j) => {
      const classInput   = document.getElementById(`sa-batch-band-class-${i}-${j}`)?.value?.trim();
      const placementRaw = document.getElementById(`sa-batch-band-placement-${i}-${j}`)?.value?.trim();
      return {
        ...e,
        classification: classInput || e.classification || null,
        placement: placementRaw ? parseInt(placementRaw, 10) : e.placement,
      };
    });

    return {
      format_id: detection?.format_id || null,
      competition: {
        name: compName, event_date: compDate,
        host_school: comp.host || null, circuit, season,
        round: compRound, classification: comp.classification || null
      },
      entries: entries.map(e => ({
        band_name: e.band_name, placement: e.placement,
        classification: e.classification || null,
        class_size: e.class_size || null,
        total_score: e.total_score, subtotal: e.subtotal, penalty: e.penalty,
        caption_scores: (e.caption_scores || []).flatMap(cs => {
          const def  = matchByRaw[cs.raw_name];
          const base = { caption_def_id: def?.caption_def_id || null, caption_raw_name: cs.raw_name, judge_name: cs.judge_name, panel_id: cs.panel_id };
          const result = [];
          if (cs.sub_score_1   != null) result.push({ ...base, sub_score_1:   cs.sub_score_1   });
          if (cs.sub_score_2   != null) result.push({ ...base, sub_score_2:   cs.sub_score_2   });
          if (cs.caption_total != null) result.push({ ...base, caption_total: cs.caption_total });
          return result;
        })
      }))
    };
  }

  window.toggleBatchCard = function(i) {
    const body   = document.getElementById(`batch-card-body-${i}`);
    const toggle = document.getElementById(`batch-card-toggle-${i}`);
    if (!body) return;
    const open = body.style.display === 'none' || body.style.display === '';
    body.style.display   = open ? '' : 'none';
    if (toggle) toggle.textContent = open ? '▲ collapse' : '▶ expand';
  };
}

// ── Batch review renderer ─────────────────────────────────────────────────────

function renderBatchReview(results) {
  const inputStyle = `background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:4px;color:inherit;padding:.2rem .4rem;font-size:.82rem;width:100%;box-sizing:border-box`;
  const selStyle   = `background:#1b2535;border:1px solid rgba(255,255,255,.15);border-radius:4px;color:inherit;padding:.2rem .4rem;font-size:.82rem`;
  const circuits   = ['TOB','CBA','MFA','UIL','BOA'];
  const placeStyle = `width:44px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:3px;color:inherit;padding:.15rem .3rem;font-size:.78rem;text-align:center`;
  const classStyle = `width:60px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:3px;color:inherit;padding:.15rem .3rem;font-size:.78rem`;

  return results.map((r, i) => {
    if (r.error || !r.extracted) {
      return `
        <div style="border:1px solid rgba(224,82,82,.3);border-radius:6px;margin-bottom:.6rem;padding:.6rem .75rem;background:rgba(224,82,82,.05);font-size:.83rem">
          <span style="color:#e05252">✗</span>
          <span style="margin-left:.5rem">${r.file.name}</span>
          <span style="margin-left:.75rem;color:#e05252">${r.error || 'extraction failed'}</span>
        </div>`;
    }

    const data = r.extracted;
    const comp = data.competition || {};
    const curCircuit = comp.circuit_guess || '';
    const curRound   = (comp.round || 'regular').toLowerCase();
    const bandCount  = (data.entries || []).length;

    const bandTableHtml = `
      <table class="sheet-table" style="margin:.4rem 0;font-size:.78rem;width:100%">
        <thead><tr><th>Place</th><th>Band</th><th>Total</th><th>Class</th></tr></thead>
        <tbody>
          ${(data.entries || []).map((e, j) => `
            <tr>
              <td><input type="number" id="sa-batch-band-placement-${i}-${j}" value="${e.placement ?? ''}" placeholder="?" min="1" style="${placeStyle}"></td>
              <td>${e.band_name}</td>
              <td>${e.total_score ?? '—'}</td>
              <td><input type="text" id="sa-batch-band-class-${i}-${j}" value="${e.classification || ''}" placeholder="1-A" style="${classStyle}"></td>
            </tr>`).join('')}
        </tbody>
      </table>`;

    return `
      <div style="border:1px solid rgba(255,255,255,.1);border-radius:6px;margin-bottom:.6rem;overflow:hidden">
        <div style="display:flex;align-items:center;gap:.75rem;padding:.55rem .75rem;cursor:pointer;background:rgba(255,255,255,.03)"
          onclick="window.toggleBatchCard(${i})">
          <span style="color:#4caf50;font-size:.85rem">✓</span>
          <span style="flex:1;font-size:.85rem;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
            ${(comp.name || r.file.name).replace(/</g,'&lt;')}
          </span>
          <span style="font-size:.78rem;color:var(--text-muted);white-space:nowrap">${bandCount} band${bandCount !== 1 ? 's' : ''}</span>
          <span id="batch-review-status-${i}" style="font-size:.78rem;color:var(--text-muted);white-space:nowrap"></span>
          <span id="batch-card-toggle-${i}" style="font-size:.72rem;color:var(--text-muted);margin-left:.25rem">▶ expand</span>
        </div>
        <div id="batch-card-body-${i}" style="display:none;padding:.75rem;border-top:1px solid rgba(255,255,255,.08);font-size:.82rem">
          <table style="width:100%;border-collapse:collapse;margin-bottom:.5rem">
            <tr>
              <td style="color:var(--text-muted);width:80px;padding-bottom:.3rem">Event</td>
              <td style="padding-bottom:.3rem"><input id="sa-batch-name-${i}" type="text" value="${(comp.name || '').replace(/"/g,'&quot;')}" placeholder="Competition name" style="${inputStyle}"></td>
            </tr>
            <tr>
              <td style="color:var(--text-muted);padding-bottom:.3rem">Date <span style="color:#e05252">*</span></td>
              <td style="padding-bottom:.3rem"><input id="sa-batch-date-${i}" type="date" value="${comp.event_date || ''}" style="${inputStyle};width:auto"></td>
            </tr>
            <tr>
              <td style="color:var(--text-muted);padding-bottom:.3rem">Circuit <span style="color:#e05252">*</span></td>
              <td style="padding-bottom:.3rem">
                <select id="sa-batch-circuit-${i}" style="${selStyle}">
                  <option value="">— select —</option>
                  ${circuits.map(c => `<option value="${c}" ${curCircuit===c?'selected':''}>${c}</option>`).join('')}
                </select>
              </td>
            </tr>
            <tr>
              <td style="color:var(--text-muted)">Round</td>
              <td>
                <select id="sa-batch-round-${i}" style="${selStyle}">
                  ${['regular','prelims','finals','championships'].map(r2 =>
                    `<option value="${r2}" ${curRound===r2?'selected':''}>${r2.charAt(0).toUpperCase()+r2.slice(1)}</option>`
                  ).join('')}
                </select>
              </td>
            </tr>
          </table>
          ${bandTableHtml}
        </div>
      </div>`;
  }).join('');
}

// ── Single-file review renderer (unchanged) ───────────────────────────────────

function renderStandaloneReview(data, detection) {
  const comp = data.competition || {};
  const matched = (detection?.matched || []);
  const matchByRaw = {};
  for (const m of matched) matchByRaw[m.raw_name] = m;
  const fmtLine = detection
    ? `<strong>${detection.format_name || 'none'}</strong> (${detection.match})`
    : '<span style="color:#888">not detected</span>';

  const inputStyle = `background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:4px;color:inherit;padding:.2rem .4rem;font-size:.85rem;width:100%;box-sizing:border-box`;
  const selStyle   = `background:#1b2535;border:1px solid rgba(255,255,255,.15);border-radius:4px;color:inherit;padding:.2rem .4rem;font-size:.85rem`;
  const circuits   = ['TOB','CBA','MFA','UIL','BOA'];
  const curCircuit = comp.circuit_guess || '';
  const curRound   = (comp.round || 'regular').toLowerCase();

  const seenPlacements = new Set();
  const hasRepeatedPlacements = (data.entries || []).some(e => {
    if (e.placement == null) return false;
    if (seenPlacements.has(e.placement)) return true;
    seenPlacements.add(e.placement); return false;
  });

  const classInputStyle = `width:60px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:3px;color:inherit;padding:.15rem .3rem;font-size:.8rem`;

  const repeatWarning = hasRepeatedPlacements
    ? `<div style="margin:.5rem 0;padding:.4rem .7rem;background:rgba(255,200,0,.07);border:1px solid rgba(255,200,0,.25);border-radius:5px;font-size:.8rem;color:#e5c900">Duplicate placement numbers — multiple classification groups detected. Correct <strong>Class</strong> and <strong>Place</strong> for each band as needed.</div>`
    : '';

  const placeInputStyle = `width:44px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);border-radius:3px;color:inherit;padding:.15rem .3rem;font-size:.8rem;text-align:center`;

  const bandTableHtml = `
    <table class="sheet-table" style="margin:.4rem 0;font-size:.8rem;width:100%">
      <thead><tr><th>Place</th><th>Band</th><th>Total</th><th>Class</th></tr></thead>
      <tbody>
        ${(data.entries || []).map((e, i) => `
          <tr>
            <td><input type="number" id="sa-band-placement-${i}" value="${e.placement ?? ''}" placeholder="?" min="1" style="${placeInputStyle}"></td>
            <td>${e.band_name}</td>
            <td>${e.total_score ?? '—'}</td>
            <td><input type="text" id="sa-band-class-${i}" value="${e.classification || ''}" placeholder="e.g. 1-A" style="${classInputStyle}"></td>
          </tr>`).join('')}
      </tbody>
    </table>`;

  return `
    <div style="font-size:.85rem;margin-bottom:.75rem">
      <table style="width:100%;border-collapse:collapse;margin-bottom:.5rem">
        <tr>
          <td style="color:var(--text-muted);width:110px;padding-bottom:.35rem">Event</td>
          <td style="padding-bottom:.35rem"><input id="sa-comp-name" type="text" value="${(comp.name || '').replace(/"/g,'&quot;')}" placeholder="Competition name" style="${inputStyle}"></td>
        </tr>
        <tr>
          <td style="color:var(--text-muted);padding-bottom:.35rem">Date <span style="color:#e05252">*</span></td>
          <td style="padding-bottom:.35rem"><input id="sa-comp-date" type="date" value="${comp.event_date || ''}" style="${inputStyle};width:auto"></td>
        </tr>
        <tr>
          <td style="color:var(--text-muted);padding-bottom:.35rem">Circuit <span style="color:#e05252">*</span></td>
          <td style="padding-bottom:.35rem">
            <select id="sa-comp-circuit" style="${selStyle}">
              <option value="">— select —</option>
              ${circuits.map(c => `<option value="${c}" ${curCircuit===c?'selected':''}>${c}</option>`).join('')}
            </select>
          </td>
        </tr>
        <tr>
          <td style="color:var(--text-muted);padding-bottom:.35rem">Round</td>
          <td style="padding-bottom:.35rem">
            <select id="sa-comp-round" style="${selStyle}">
              ${['regular','prelims','finals','championships'].map(r =>
                `<option value="${r}" ${curRound===r?'selected':''}>${r.charAt(0).toUpperCase()+r.slice(1)}</option>`
              ).join('')}
            </select>
          </td>
        </tr>
        <tr>
          <td style="color:var(--text-muted)">Format</td>
          <td>${fmtLine}</td>
        </tr>
      </table>
      <strong>Captions (${(data.raw_captions || []).length})</strong><br>
      ${(data.raw_captions || []).map(c => {
        const m = matchByRaw[c.raw_name];
        const badge = m ? `<span style="color:#4caf50;font-size:.75rem">✓</span>` : `<span style="color:#888;font-size:.75rem">·</span>`;
        return `<span style="margin-right:.5rem;font-size:.8rem">${badge} ${c.raw_name}</span>`;
      }).join('')}
      ${repeatWarning}
      <strong>Bands (${(data.entries || []).length})</strong>
      ${bandTableHtml}
    </div>`;
}

function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
